import AddToHomeScreen from './add-to-home-screen';

export default AddToHomeScreen;